<template>

    <GoogleSignInButton
        :width="318"
        logo-alignment="center"
        text="signin_with"
        shape="rectangular"
        theme="outline"
        :locale="googleBtnLang"
        @success="handleOnSuccess"
        @failed="handleOnError" />

</template>
<script setup lang="ts">
import { GoogleSignInButton } from 'vue3-google-signin';
import { useGoogleLogin } from '../composables/use-google-login';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import _ from 'lodash'

const { locale } = useI18n()

const { handleOnSuccess, handleOnError } = useGoogleLogin();

 enum E_LanguageLong {
    en = 'en_US',
    cn = 'zh_CN',
    tw = 'zh_TW',
    jp = 'ja_JP'
}

const googleBtnLang = computed(() => {
    return _.get(E_LanguageLong, locale.value)
})

</script>
